import React from "react"
import styled from "styled-components"
import { Button, FormControl as BootStrapFormControl, Modal, Table } from "react-bootstrap"

import FilterProducts from "../../../Products/components/Filter"

import { searchProducts } from "../../../../../api/products";
import { formatCurrencyValue } from "../../../../../utils";


const AutoComplete = styled.div`
    margin-bottom: 10px;
`
const AutoCompleteInputArea = styled.div`
    display: flex;
    flex-direction: row;`

const AutoCompleteResultArea = styled.div`
    -webkit-box-shadow: -2px 15px 16px -10px rgba(74,142,179,1);
    -moz-box-shadow: -2px 15px 16px -10px rgba(74,142,179,1);
    box-shadow: -2px 15px 16px -10px rgba(74,142,179,1);
`

const FormControl = styled(BootStrapFormControl)`
    padding-top: 25px;
    padding-bottom: 25px;
    padding-left: 40px;
    padding-right: 60px;
    border-radius: 30px;
`
const EllipsisArea = styled.div`
    position: absolute;
    font-size: 2em;
    right: 35px;
    top: 13px
    cursor: pointer;
    border-radius: 6px;
    padding-left: 10px;
    padding-right: 10px;
`
const SearchIconButton = styled(Button)`
    border-radius: 0px
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    i  {
        font-zize: 1.2em;
    }
`
const LeftSearchIcon = styled.div`
    position: absolute;
    cursor: pointer
    top: 20px;
    left: 30px;

    i {
        font-size: 1.6em;
    }
`

const DEFAULT_SEARCH_PARAMS = { end_count: 10, entryTextSearch: "" }

export default class Autocomplete extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            params: DEFAULT_SEARCH_PARAMS,
            result: [],
            showFilterProducts: false
        }
        this.onSearch = this.onSearch.bind(this)
        this._openModalFilterItems = this._openModalFilterItems.bind(this)
        this._closeModalFilterItems = this._closeModalFilterItems.bind(this)
        this.onIconSearchClick = this.onIconSearchClick.bind(this)
    }
    onIconSearchClick() {
        const e = {
            target: {
                value: this.state.params.entryTextSearch
            },
            key: "Enter"
        }
        this.onSearch(e)
    }
    onSearch(e) {
        let params = {
            "entryTextSearch": this.state.params.entryTextSearch
        }
        const { value } = e.target

        if (isNaN(value)) {
            params["name"] = value
        } else {
            if (value.length >= 8) {
                params["barcode"] = value
            } else {
                params["code"] = value
            }
        }
        params["entryTextSearch"] = value
        this.setState({ ...this, params })
        if (e.key === "Enter") {
            document
                .getElementById("c190-4a2f-a989")
                .textContent = ""
            this.setState({ ...this, loading: true })
            searchProducts(this.state.params)
                .then(result => {
                    this.setState({ ...this, loading: false })
                    if (result.length) {
                        this._setFocus()
                        if (result.length === 1) {
                            this.onClick(result[0])
                        } else {
                            this.setState({ ...this, result })
                        }
                    } else {
                        document
                            .getElementById("c190-4a2f-a989")
                            .textContent = "Nenhum item encontrado"
                    }
                })
                .catch(() => {
                    this.setState({ ...this, loading: false })
                    this._setFocus()
                })
        }
    }
    _openModalFilterItems() {
        this.setState({ ...this, showFilterProducts: true })
    }
    _closeModalFilterItems() {
        this.setState({ ...this, showFilterProducts: false })
    }
    onClick(item) {
        this.props.onClick(item)
        this.setState({ ...this, result: [], params: DEFAULT_SEARCH_PARAMS, showFilterProducts: false })
    }
    _setFocus() {
        setTimeout(() => {
            try {
                document.getElementById("pos-search-items-autocomplete").focus()
            } catch (error) { }
        }, 400)
    }

    componentDidMount() {
        this._setFocus()
    }

    render() {
        return <AutoComplete>
            <AutoCompleteInputArea>
                <LeftSearchIcon
                    title="Pesquisar"
                    onClick={this.onIconSearchClick}
                    className="fas fa-search"
                />
                <FormControl
                    id="pos-search-items-autocomplete"
                    placeholder="Pesquise pelo nome, código ou código de barras do item"
                    value={this.state.params.entryTextSearch}
                    onKeyDown={this.onSearch}
                    onChange={this.onSearch}
                    disabled={this.state.loading}
                />
                <EllipsisArea
                    onClick={this._openModalFilterItems}
                    loading={this.state.loading}
                    title="Mais filtros"
                    className="fas fa-ellipsis-v"
                />
            </AutoCompleteInputArea>
            <span className="text-danger" id="c190-4a2f-a989"></span>
            <AutoCompleteResultArea
                className={this.state.result.length > 0 ? "d-block" : "d-none"}>
                <Table striped hover bordered responsive >
                    <thead>
                        <tr>
                            <th>
                                Cod.
                            </th>
                            <th>
                                Cod. Barras
                            </th>
                            <th>
                                Descrição
                            </th>
                            <th>
                                Estoque
                            </th>
                            <th>
                                Valor
                            </th>
                            <th>
                                Ações
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.result.map((item, index) => {
                                item.stockQuantity = false;
                                const price = formatCurrencyValue(item.sellable.price)

                                if (item.stock) {
                                    item.stockQuantity = item.stock.quantity
                                }
                                return <tr
                                    key={`pos-autocomplete-result-item-${item.id}-${index}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.onClick(item)}>
                                    <td>{item.sellable.code}</td>
                                    <td>{item.sellable.barcode}</td>
                                    <td>{item.sellable.name}</td>
                                    <td>{item.stockQuantity}</td>
                                    <td>{price}</td>
                                    <td><Button>Adicionar</Button></td>
                                </tr>

                            })
                        }
                    </tbody>
                </Table>
            </AutoCompleteResultArea>
            <Modal
                show={this.state.showFilterProducts}
                size="lg"
                onHide={this._closeModalFilterItems}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Pesquisar itens
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FilterProducts onClick={item => this.onClick(item)} />
                </Modal.Body>

            </Modal>
        </AutoComplete >
    }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/AutoComplete/index.jsx